import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1b1e03cc&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1e03cc')) {
      api.createRecord('1b1e03cc', component.options)
    } else {
      api.reload('1b1e03cc', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1b1e03cc&", function () {
      api.rerender('1b1e03cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/Index.vue"
export default component.exports